module.exports = __webpack_public_path__ + "static/img/2_1_4.19eceb91.jpg";